<!--
	功能：该组件用于实现单选框的相关显示及控制
	可提供如下功能, 支持的形态及功能有:
		1.  设置单选框的边框颜色(bdrClr)
		2.  设置单选框的选中圆点颜色(circClr)
		3.  设置单选框的使能状态(disabled)
		4.  设置单选框的默认选中状态(checked)
		5.  设置单选框的(圆形)大小(size)
		6.  设置单选框的提示文字(capt)
		7.  设置单选框的点击响应事件(myClick)
		8.  设置单选框的值(val)
		9.  设置单选框分组(grpName), 同一分组的单选框间具有互斥性(属于同一个Vue祖先对象时)
		10. 获取同一分组选中单选框的值(getRadioValueByName)
		11. 禁用/启用指定单选框(setDisabled)
		12. 选中/取消选中指定的单选框(setChecked)
	组件调用参数:
		参数名        必要性   值域        说明
		root          必须     Vue对象     单选框所属祖先对象(用于完成分组控制, 需要作为同一分组控制的单选框, 需要指定相同的祖先对象)
		grpName       必须     string      单选框所属的分组名称
		size          必须     int         单选框的原型边框大小(组件可见边框将会比该size小2个像素, 确保与周围组件至少有1个像素可见间隙)
		val           必须     string      单选框的值
		circClr       可选     #xxxxxx     单选框的选中圆点的颜色
		bdrClr        可选     #xxxxxx     单选框的可见边框的颜色
		capt          可选     string      单选框的提示文字
		checked       可选     bool        单选框的默认选中状态
		disabled      可选     bool        单选框的使能状态
		myClick       可选     function    单选框的点击响应事件, 事件参数为( newValue, oldValue )
	输出的值:
		$emit("input")    可用 v-model 接收参数值
	外部调用方法:
		setDisabled: function( flag )     //禁用或启用组件, true-禁用, false-启用
		setChecked:  function( flag )     //设置组件的选中状态, true-选中, false-不选中, 会更新v-model指定的变量, 但是不调用 myClick 指定的事件
	Vue方法:
		getRadioValueByName: function( pRoot, pGrpName )  //获取指定 Vue 对象下属于同一分组选中单选框的值, 笨方法用于内部分组处理, 不需要使用者调用
-->

<template>
	<div id="idRadioPanel" ref="idRadioPanel">
		<div id="idRadBdr" ref="idRadBdr" @click="onRadClick">
			<div id="idRadCirc" ref="idRadCirc"></div>
		</div>
		<div id="idRadCapt" ref="idRadCapt">{{capt}}</div>
	</div>
</template>

<script>

import Vue from 'vue'

/* private 获取某个指定的 Vue 对象下, 具有同一分组名称的单选框的选中值 */
/*
Vue.prototype.getRadioValueByIds=function( objs ){
	let v="";
	for( let i=0; i<objs.length; i++ )
	{
		if( objs[i].myChecked ) return objs[i].myVal;
	}
	return "";
}
*/
export default {
	name: 'CRadio',
	props:['size', 'bdrClr', 'circClr', 'val', 'checked', 'disabled', 'myClick', 'capt', 'grpName', 'root'],
	data () {
		return {
			w:  this.size,                 //组件的尺寸
			w1: this.size-2,               //组件的可见边框的尺寸
			myBdrClr: "",                  //组件当前的边框颜色
			myCircClr: "",                 //组件当前的选中圆点的颜色
			myDisabled: this.disabled,     //组件当前的使能状态
			myChecked: false,              //组件当前的选中状态
			myVal: "",                     //组件当前的值
		}
	},
	mounted: function(){
		let bdr=this.$refs["idRadBdr"];
		if( (this.w1 % 2)==1 ) this.w1 = this.w1+1;
		bdr.style["width"]  = (this.w1)+"px";
		bdr.style["height"] = (this.w1)+"px";
		bdr.style["border-radius"] = (this.w1/2)+"px";

		let w2=this.w1-8;
		let circ=this.$refs["idRadCirc"];
		circ.style["width"]  = (w2)+"px";
		circ.style["height"] = (w2)+"px";
		circ.style["border-radius"] = (w2/2)+"px";
		let capt=this.$refs["idRadCapt"];

		if( !this.disabled ) this.myDisabled = false;

		this.myChecked = this.checked;
		if( this.myChecked )   //处理默认选中状态
		{
			let obj=this.getCheckedRadio( this.root.obj, this.grpName );
			if( obj ) obj.setChecked( false );

			if( this.circClr ) this.myCircClr = this.circClr;  else this.myCircClr = "#4a4a4a";
			this.setChecked( true );
		}
		if( this.myDisabled )    //如果是禁用的
		{
			bdr.style["border"] = "1px solid #b4b4b4";
			circ.style["background"] = "#b4b4b4";
			this.myBdrClr  = "#b4b4b4";
			this.myCircClr = "#b4b4b4";
			capt.style["color"] = "#b4b4b4";
		}
		else   //正常可用状态
		{
			if( this.bdrClr  )
			{
				bdr.style["border"] = "1px solid "+this.bdrClr;
				this.myBdrClr = this.bdrClr;
			}
			else
			{
				this.myBdrClr = "#4a4a4a";
			}

			if( this.circClr )
			{
				circ.style["background"] = this.circClr;
				this.myCircClr = this.circClr;
			}
			else
			{
				this.myCircClr = "#4a4a4a";
			}
		}
	},
	methods:{
		/* public  设置组件的选中状态, 不会调用 myClick 响应事件, 但是会更新 v-model指定的变量值 */
		setChecked: function( flag ){
			let circ=this.$refs["idRadCirc"];
			if( flag )
			{
				let obj=this.getCheckedRadio( this.root.obj, this.grpName );
				if( obj ) obj.setChecked( false );

				this.myChecked = true;
				circ.style["background"] = this.myCircClr;
				this.myVal = this.val;
				this.$emit("input", this.myVal );
			}
			else
			{
				this.myChecked = false;
				circ.style["background"] = "#ffffff";
				this.myVal = "";
				this.$emit("input", "");
			}
		},
		/* public  设置组件的使能状态 */
		setDisabled: function( flag ){
			if( flag )
			{
				this.$refs["idRadBdr"].style["border"] = "1px solid #b4b4b4";
				if( this.myChecked )
					 this.$refs["idRadCirc"].style["background"] = "#b4b4b4";
				else this.$refs["idRadCirc"].style["background"] = "#ffffff";

				this.myBdrClr = "#b4b4b4";
				this.$refs["idRadCapt"].style["color"] = "#b4b4b4";
				this.myDisabled = true;
			}
			else
			{
				this.myBdrClr = "#4a4a4a";
				this.$refs["idRadCapt"].style["color"] = "#4a4a4a";
				this.$refs["idRadBdr"].style["border"] = "1px solid "+this.myBdrClr;
				if( this.myChecked ) this.$refs["idRadCirc"].style["background"] = this.myCircClr;  else this.$refs["idRadCirc"].style["background"] = "#ffffff";
				this.myDisabled = false;
			}
		},
		/* private   组件的点击响应事件 */
		onRadClick: function(){
			if( this.myDisabled ) return;   //禁用模式下, 不响应

			//处理选中状态
			if( this.myChecked )
			{
				let obj=this.getCheckedRadio( this.root.obj, this.grpName );
				if( obj == this ) return;  //确保至少选中一个

				this.this.setChecked( false );
				if( this.myClick ) this.myClick( this.myVal, this.val );
			}
			else
			{
				this.setChecked( true );
				if( this.myClick ) this.myClick( this.myVal, "" );
			}
		},
		/* private   取得当前分组中选中的单选框组件对象 */
		getCheckedRadio: function( pRoot, pGrpName ){
			let objs=pRoot.$children;
			for( let i=0; i<objs.length; i++ )
			{
				if( objs[i].$options.name == "CRadio" )
				{
					if( objs[i].grpName == pGrpName && objs[i].myChecked == true ) return objs[i];
				}
				let obj=this.getCheckedRadio( objs[i], pGrpName );
				if( obj ) return obj;
			}
			return null;
		},
	}
}

</script>

<style scoped>

#idRadioPanel{ flex:0 0 auto; position:relative; display:flex; flex-direction:row; align-items:center; border:0px solid red; }
#idRadBdr{ float:left; margin-left:1px; margin-top:1px; border:1px solid #4a4a4a; cursor:pointer; }
#idRadCirc{ flex:0 0 auto; text-align:center; border:0px solid red; margin-top:3px; margin-left:3px; }
#idRadCapt{ flex:0 0 auto; text-align:center; text-indent:4px; border:0px solid red; margin-top:-1px; padding-right:4px; }

</style>



// WEBPACK FOOTER //
// cradio.vue?7d1c3514